export const FindOption = (data: any, id: number) => {
  return data?.find((item: any) => item.variation_id == id);
};
